import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useAuth } from 'hooks/UseAuth'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'
import { useRootStore } from 'stores/RootStore'
import { setDatadogUser } from 'datadogRum'

export const DatadogUserInfo = observer(() => {
  const auth = useAuth()
  const isAutopilot = useIsVirtualMarketer()
  const { tierUsageStore } = useRootStore()
  const plan = tierUsageStore.currentSubscription?.plan

  useEffect(() => {
    if (auth?.id && auth?.email) {
      setDatadogUser({
        id: auth.id,
        email: auth.email,
        isAutopilot: !!isAutopilot,
        plan,
      })
    }
  }, [auth?.id, auth?.email, isAutopilot, plan])

  return null
})
